export default __webpack_public_path__ + "static/media/blurbg.5f5675be.png";